import React from 'react'
import capitalize from 'lodash/capitalize'

const ImageAttribution = ({ attribution }) => {
  const { provider, author, direct } = attribution

  if (!provider) {
    return null
  }

  // Build provider suffix
  const providerSuffix = `${provider} Images.`.split(' ').map(capitalize).join(' ')

  // Build author span
  const authorSpan = author ? (
    direct ? (
      <a href={direct} target='_blank' rel='noreferrer'>
        {author}.
      </a>
    ) : (
      `${author}.`
    )
  ) : (
    ''
  )

  return (
    <span className='image-attribution'>
      {authorSpan} {providerSuffix}
    </span>
  )
}

export default ImageAttribution
